import BenchmarkCompareContainer from './containers/BenchmarkCompareContainer';

export default BenchmarkCompareContainer;
